<script setup lang="ts">
import HighlightedText from "@/components/ClientDetail/AlphabeticalList/HighlightedText.vue";
import PermissionInfo from "../PermissionInfo.vue";

export type ClientFunctionItem = {
  id: string;
  label: string;
  keywords?: string[];
  icon: string;
  disabled?: boolean;
  reason?: string;
};

defineProps<{ items: ClientFunctionItem[]; highlight?: string }>();
const emit = defineEmits<{ select: [id: string] }>();
</script>

<template>
  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
    <div v-for="item in items" :key="item.id" class="relative">
    <button
      type="button"
      :disabled="item.disabled"
      :title="item.reason"
      :aria-label="item.reason ? `${item.label}: ${item.reason}` : item.label"
      class="border-base-200 bg-base-100 flex h-full min-h-16 w-full items-center gap-3 border p-4 text-left shadow-sm transition-colors enabled:hover:border-primary enabled:hover:bg-primary/5 disabled:cursor-not-allowed disabled:opacity-50"
      :class="{ 'pr-12': item.reason }"
      @click="emit('select', item.id)"
    >
      <i :class="[item.icon, 'w-5 text-center text-primary']" aria-hidden="true"></i>
      <span class="font-medium"><HighlightedText v-if="highlight" :text="item.label" :highlight="highlight" /><template v-else>{{ item.label }}</template></span>
    </button>
    <PermissionInfo v-if="item.reason" :message="item.reason" class="absolute right-2 top-1/2 -translate-y-1/2" />
    </div>
  </div>
</template>
